var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMynauiPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mynaui:pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7333 26.932C11.0506 27.6151 10.1245 27.9993 9.15867 28H4V22.8747C4 21.9093 4.384 20.9827 5.06667 20.3M11.7333 26.932L5.06667 20.3M11.7333 26.932L25.032 13.628M5.06667 20.3L18.3787 6.97333L20.28 5.06933C20.6183 4.73048 21.0201 4.46163 21.4624 4.27816C21.9047 4.09468 22.3789 4.00018 22.8577 4.00006C23.3366 3.99994 23.8107 4.09419 24.2531 4.27744C24.6955 4.46068 25.0975 4.72932 25.436 5.068L26.9373 6.57067C27.6207 7.25405 28.0046 8.1809 28.0046 9.14733C28.0046 10.1138 27.6207 11.0406 26.9373 11.724L25.032 13.628M25.032 13.628L18.3773 6.97333",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMynauiPencil);
export default __webpack_public_path__ + "static/media/mynaui_pencil.321b98101692f37e053ea1afbb1eba45.svg";
export { ForwardRef as ReactComponent };